'use strict';

import { view } from '@/functions';

const prefix = '/payouts';
export default [
    {
        path: prefix,
        name: 'payouts',
        meta: {
            title: 'Payouts',
            scopes: ['read_payouts', 'write_payouts']
        },
        component: () => view('payouts/index'),
    },
    {
        path: `${prefix}/info`,
        name: 'payouts-info',
        meta: {
            title: 'Payouts',
            scopes: ['read_payouts', 'write_payouts']
        },
        component: () => view('payouts/info'),
    }
];
